import * as ActionTypes from '../constants/action_types'
import * as utils from './utils'

// -----------------------------------------------------------------------------
// API Calls

function fetchThread (assistantId, user) {
  const body = {
    assistant_name: assistantId,
    user_id: user
  }
  return utils.makeApiCall({
    url: '/api/ai/v1/thread/start',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_THREAD,
    actionReceive: ActionTypes.RECEIVE_THREAD,
    actionFailure: ActionTypes.REQUEST_THREAD_FAILURE,
    authenticated: false,
    actionProps: {
      assistantId: assistantId,
      userId: user
    }
  })
}
function fetchChat (message, threadId, assistantId, isBurner, burnerId, user) {
  const body = {
    prompt: message,
    thread_id: threadId,
    assistant_name: assistantId,
    isBurner: isBurner,
    burnerId: burnerId,
    timestamp: new Date().toISOString(),
    user_id: user
    //other: opt str
  }
  return utils.makeApiCall({
    url: '/api/ai/v1/chat',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_CHAT,
    actionReceive: ActionTypes.RECEIVE_CHAT,
    actionFailure: ActionTypes.REQUEST_CHAT_FAILURE,
    authenticated: false,
    actionProps: {
      threadId: threadId,
      assistantId: assistantId,
      message: message,
      isBurner: isBurner,
      burnerId: burnerId,
      userId: user
    }
  })
}


// -----------------------------------------------------------------------------
// User invokable actions

export function fetchThreadIfNeeded (assistantId, user) {
  return (dispatch) => {
    return dispatch(fetchThread(assistantId, user))
  }
}

export function fetchChatIfNeeded (message, threadId, assistantId, isBurner, burnerId, user) {
  return (dispatch) => {
    return dispatch(fetchChat(message, threadId, assistantId, isBurner, burnerId, user))
  }
}